import React from "react";
import { toast } from "sonner";
import { CarTaxiFront, Bus, Plane, CarFront, ChevronRight, ArrowRight } from "lucide-react";

const CARDS = [
  { id: "taxi", img: "/aya/transport/tp_taxi.jpg", Icon: CarTaxiFront, l1: "Réserver", l2: "un taxi", route: "/transport/taxi" },
  { id: "car", img: "/aya/transport/tp_car.jpg", Icon: Bus, l1: "Car", l2: "interurbain", route: "/transport/car" },
  { id: "avion", img: "/aya/transport/tp_avion.jpg", Icon: Plane, l1: "Réserver", l2: "un billet d'avion", route: "/transport/avion" },
  { id: "chauffeur", img: "/aya/transport/tp_chauffeur.jpg", Icon: CarFront, l1: "Chauffeur", l2: "privé", route: "/transport/chauffeur" },
];

export default function TransportSection({ navigate }) {
  const open = (c) => (c.route ? navigate(c.route) : toast.info("Bientôt disponible."));
  return (
    <section id="transport-section" style={St.wrap} data-testid="transport-section">
      <div style={St.head}>
        <span style={St.icon}><CarTaxiFront size={15} color="var(--ah-accent, #34D399)" /></span>
        <span style={St.accentBar} aria-hidden="true" />
        <div style={{ flex: 1, minWidth: 0 }}>
          <h2 style={St.title}>Transport</h2>
          <p style={St.sub}>Tous vos déplacements en Côte d'Ivoire</p>
        </div>
        <button style={St.more} data-testid="transport-see-all" onClick={() => navigate("/transport")}>
          Voir tout <ArrowRight size={12} color="#F97316" />
        </button>
      </div>
      <div style={St.row} data-testid="transport-cards">
        {CARDS.map((c) => (
          <button key={c.id} style={St.card} data-testid={`transport-card-${c.id}`} onClick={() => open(c)}>
            <img src={c.img} alt={`${c.l1} ${c.l2}`} style={St.img} loading="lazy" />
            <span style={St.bottom}>
              <c.Icon size={15} color="var(--ah-accent, #34D399)" strokeWidth={2.2} style={{ flexShrink: 0 }} />
              <span style={St.label}>{c.l1}<br />{c.l2}</span>
              <span style={St.chev}><ChevronRight size={13} color="#0B3B27" strokeWidth={2.8} /></span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}

const St = {
  wrap: { marginTop: 11, padding: "10px 10px 9px", borderRadius: 15, background: "var(--ah-surface)", border: "1px solid var(--ah-border)" },
  head: { display: "flex", alignItems: "center", gap: 8, marginBottom: 9 },
  accentBar: { width: 3, height: 26, borderRadius: 2, background: "#F97316", flexShrink: 0 },
  icon: { width: 26, height: 26, borderRadius: 8, background: "rgba(16,185,129,0.18)", border: "1px solid var(--ah-border-strong)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  title: { fontSize: 14.5, fontWeight: 800, margin: 0, color: "var(--ah-title)", lineHeight: 1.1 },
  sub: { fontSize: 10, color: "var(--ah-muted)", margin: "1px 0 0" },
  more: { display: "inline-flex", alignItems: "center", gap: 4, height: 26, padding: "0 10px", borderRadius: 999, border: "1px solid var(--ah-border-strong)", background: "var(--ah-surface-elev)", color: "var(--ah-soft)", fontSize: 10.5, fontWeight: 700, cursor: "pointer", flexShrink: 0 },
  row: { display: "flex", gap: 8, overflowX: "auto", scrollbarWidth: "none", paddingBottom: 2 },
  card: { flex: "0 0 148px", padding: 0, borderRadius: 13, overflow: "hidden", background: "var(--ah-surface-elev)", border: "1px solid var(--ah-border)", cursor: "pointer", textAlign: "left", color: "var(--ah-text)" },
  img: { width: "100%", height: 76, objectFit: "cover", display: "block" },
  bottom: { display: "flex", alignItems: "center", gap: 6, padding: "7px 8px" },
  label: { flex: 1, fontSize: 10.5, fontWeight: 700, lineHeight: 1.2, minWidth: 0 },
  chev: { width: 22, height: 22, borderRadius: "50%", background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
};
